import { PDFViewer } from "@/components/PDFViewer";
import { ThemeProvider } from "next-themes";

const Index = () => {
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <PDFViewer />
    </ThemeProvider>
  );
};

export default Index;
